/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ plan: NonNullable<unknown>, date: NonNullable<unknown> }} Settings_Sub_NextInputs */

const en_settings_sub_next = /** @type {(inputs: Settings_Sub_NextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Next: ${i?.plan} starts ${i?.date}`)
};

const id_settings_sub_next = /** @type {(inputs: Settings_Sub_NextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Berikutnya: ${i?.plan} mulai ${i?.date}`)
};

/**
* | output |
* | --- |
* | "Next: {plan} starts {date}" |
*
* @param {Settings_Sub_NextInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const settings_sub_next = /** @type {((inputs: Settings_Sub_NextInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Sub_NextInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_settings_sub_next(inputs)
	return en_settings_sub_next(inputs)
});